/* eslint-disable @typescript-eslint/no-unused-vars */
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, Grid,  LinearProgress,   Paper, Snackbar, SnackbarCloseReason } from '@mui/material';
import { useState } from 'react';
import { AutoCompletePeriodo01 } from '../../../shared/forms';
import { FolhaService } from '../../../shared/services/api/rh/folha/FolhaService';
           
export const GeraFinanceiro: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false); 
  const [periodo, setPeriodo] = useState('');  
  const [periodos, setPeriodos] = useState('');
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
    
      
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpenmsg(false);
  };
       
  const handlPeriodo = (fperiodo: string | undefined) => {
    if (fperiodo != null) {
      setIsLoading(true);
      const ames = fperiodo.slice(0, -5);         
      const aano = fperiodo.slice(-4);
      const aperiodo = `${ames}%2f${aano}`;   
      const aperiodos = `${ames}/${aano}`;    
      setPeriodos(aperiodos);    
      setPeriodo(aperiodo);      
      setIsLoading(false);            
    }       
  };
                       
  const handleGera = () => {            
    setIsLoading(true);                         
    FolhaService                 
      .GeraFinanceiro(periodo)      
      .then((result) => {           
        setIsLoading(false);              
        if (result instanceof Error) {                
          setTms('error');
          setMsg(result.message);
          setOpenmsg(true);                     
        }else {   
          setTms('success');
          setMsg('Gerada Com sucesso!');
          setOpenmsg(true);
        }             
      });              
  };   
                                                           
  return (
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}
          variant="filled"
          sx={{ width: '100%' }}
        >
          {msg}
        </Alert>
      </Snackbar>
      <Box gap={1}  display="flex" alignItems="center" alignSelf='center' margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
        alignContent='center'>       
        <DialogTitle>Gera Financeiro</DialogTitle>
        <DialogContent  dividers>    
          {isLoading && (             
            <Grid item>        
              <LinearProgress variant='indeterminate' />       
            </Grid>                              
          )}   
          <Grid container  padding={1} item direction="row" gap={2}>
            <Grid container spacing={2} item direction="row" xs={12} sm={12} md={12} lg={12} xl={12}>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <AutoCompletePeriodo01 
                  isExternalLoading={isLoading}
                  novoperiodo={handlPeriodo} />
              </Grid> 
            </Grid> 
          </Grid>         
        </DialogContent>     
        <DialogActions>
          <Button variant='contained' autoFocus onClick={handleGera}>Gera</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   